module.exports = __webpack_public_path__ + "0daa9c063d3982ef12254dc807bc9796.svg";